import { CallAPI } from "../../apiManager/ApiCall";
import { pushURL } from "../../apiManager/APIConfig";

export const SendPush = async (body) => {
  try {
    const response = await CallAPI({ url: pushURL, method: "POST", body });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** List all sent push notifications (admin) */
export const GetPushList = async () => {
  try {
    const response = await CallAPI({ url: `${pushURL}/list`, method: "GET" });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Update a notification record (admin, no re-send) */
export const UpdatePush = async ({ id, title, subTitle, body, link, image, type }) => {
  try {
    const response = await CallAPI({
      url: `${pushURL}/${id}`,
      method: "PUT",
      body: { title, subTitle, body, link, image, type },
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Delete a notification record (admin) */
export const DeletePush = async (id) => {
  try {
    const response = await CallAPI({ url: `${pushURL}/${id}`, method: "DELETE" });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
